module.exports = __webpack_public_path__ + "static/media/6.c8bf0c33.JPG";